import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Stack,
  Chip,
  Button,
} from '@mui/material';

const AppliedFiltersDisplay = ({
  appliedFilters,
  onRemoveFilter,
  onClearAll,
}) => {
  if (appliedFilters.length === 0) {
    return null;
  }
  return (
    <Box mb={2}>      <Typography variant="subtitle2" gutterBottom>
        Applied Filters:
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
        {appliedFilters.map((filter) => (
          <Chip
            key={filter.id}
            label={filter.name}
            onDelete={() => onRemoveFilter(filter.id)}
            color="primary"
            variant="outlined"
          />
        ))}        <Button size="small" onClick={onClearAll} color="error" variant="contained">
          Clear All
        </Button>
      </Stack>
    </Box>
  );
};

AppliedFiltersDisplay.propTypes = {
  appliedFilters: PropTypes.array.isRequired,
  onRemoveFilter: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
};

export default AppliedFiltersDisplay;
